import { render, staticRenderFns } from "./CrewPicker.vue?vue&type=template&id=6bf2e52b&scoped=true&lang=pug&"
import script from "./CrewPicker.vue?vue&type=script&lang=js&"
export * from "./CrewPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2e52b",
  null
  
)

export default component.exports